import React, { useCallback } from 'react'

import SelectDropdown from './SelectDropDown'

export default function LineHeightFormatter({ editor }) {
  const value = editor.getTailwindValue({ name: 'lineHeight', extensionName: 'paragraph' })?.value
  const handleClickOption = useCallback(lineHeight => {
    lineHeight = lineHeight.replace('px', '')
    const newValue = lineHeight === 'Normal' || `${lineHeight}px` === value ? null : lineHeight
    return editor.commands.setLeading(newValue)
  }, [editor, value])

  return <SelectDropdown
    options={SIZES}
    onChange={handleClickOption}
    tooltipText='Line Height'
    value={value}
    creatable
  />
}

const SIZES = ['Normal', '12px', '16px', '20px', '24px', '28px', '32px', '36px', '40px', '48px', '56px', '64px']
